module.exports = __webpack_public_path__ + "img/white-lily.033b10a7.jpg";